export default "__VITE_ASSET__3befe74b__"